/**
 * NOTE: The below colors were generated automatically
 * Generated on Fri, 23 Jun 2023 09:14:33 GMT
 */

import _ from "lodash"

const updatedColorTokens = {
  blue: {
    "50": "#F8FAFE",
    "100": "#E6EFFE",
    "200": "#ADC9FA",
    "300": "#7CA9F7",
    "400": "#4A89F4",
    "500": "#2164DA",
    "600": "#1552BC",
    "700": "#1248A4",
    "800": "#103E8F",
    "900": "#0C2E6A",
  },
  purple: {
    "50": "#FBF8FF",
    "100": "#EFE7FF",
    "200": "#C9B3FF",
    "300": "#AA90FA",
    "400": "#8C73DB",
    "500": "#6D58BB",
    "600": "#5543A4",
    "700": "#493897",
    "800": "#3B2E8A",
    "900": "#271E78",
  },
  brand: {
    primary: {
      "50": "#F8FAFE",
      "100": "#E6EFFE",
      "200": "#ADC9FA",
      "300": "#7CA9F7",
      "400": "#7CA9F7",
      "500": "#2164DA",
      "600": "#1552BC",
      "700": "#1248A4",
      "800": "#103E8F",
      "900": "#0C2E6A",
    },
    illustration: {
      "50": "#FBF8FF",
      "100": "#EFE7FF",
      "200": "#C9B3FF",
      "300": "#AA90FA",
      "400": "#8C73DB",
      "500": "#6D58BB",
      "600": "#5543A4",
      "700": "#493897",
      "800": "#3B2E8A",
      "900": "#271E78",
    },
    secondary: {
      "50": "#f8f9fa",
      "100": "#e9eaee",
      "200": "#babecb",
      "300": "#9aa0b3",
      "400": "#7b849c",
      "500": "#5d6785",
      "600": "#465173",
      "700": "#3c4764",
      "800": "#333c56",
      "900": "#272d41",
    },
  },
  base: {
    content: {
      default: "#3c4764",
      strong: "#272d41",
      medium: "#666C7A",
      brand: "#2164DA",
      inverse: "#ffffff",
    },
    canvas: {
      default: "#ffffff",
      alt: "#F8F9F9",
      backdrop: "#EDEDED",
      "brand-subtle": "#F8FAFE",
      inverse: "#3A3E46",
      overlay: "rgba(58, 62, 70, 0.8)",
    },
    divider: {
      subtle: "#F8F9F9",
      medium: "#EDEDED",
      strong: "#BFC2C8",
      inverse: "#ffffff",
      brand: "#2164DA",
    },
  },
  red: {
    "50": "#fef7f7",
    "100": "#FBE9E9",
    "200": "#f4acac",
    "300": "#ee8080",
    "400": "#e74f4f",
    "500": "#c03434",
    "600": "#992a2a",
    "700": "#852424",
    "800": "#721f1f",
    "900": "#571717",
  },
  green: {
    "50": "#F5FAFA",
    "100": "#E2EEED",
    "200": "#98CCC7",
    "300": "#63B1AA",
    "400": "#2D978C",
    "500": "#0F796F",
    "600": "#0C5F57",
    "700": "#0A524B",
    "800": "#09463F",
    "900": "#073430",
  },
  yellow: {
    "50": "#fffae1",
    "100": "#FFDA68",
    "200": "#E2B73E",
    "300": "#C4992A",
    "400": "#A77C18",
    "500": "#8B6005",
    "600": "#704C00",
    "700": "#624200",
    "800": "#533800",
    "900": "#3f2b00",
  },
  slate: {
    "50": "#f8f9fa",
    "100": "#e9eaee",
    "200": "#babecb",
    "300": "#9aa0b3",
    "400": "#7b849c",
    "500": "#5d6785",
    "600": "#465173",
    "700": "#3c4764",
    "800": "#333c56",
    "900": "#272d41",
  },
  grey: {
    "50": "#F8F9F9",
    "100": "#EDEDED",
    "200": "#BFC2C8",
    "300": "#A0A4AD",
    "400": "#838894",
    "500": "#666C7A",
    "600": "#505660",
    "700": "#454953",
    "800": "#3A3E46",
    "900": "#2C2E34",
  },
  standard: {
    white: "#ffffff",
    black: "#000000",
  },
  skin: {
    "1base": "#FFCAA4",
    "1shadow": "#F5B896",
    "2base": "#EBA687",
    "2shadow": "#E29B7B",
    "3base": "#D98F6F",
    "3shadow": "#CE8361",
    "4base": "#BF7657",
    "4shadow": "#AF6D53",
    "5base": "#9F634F",
    "5shadow": "#8B5544",
    "6base": "#764738",
    "6shadow": "#633D32",
  },
  interaction: {
    main: {
      default: "#2164DA",
      hover: "#1552BC",
      active: "#1248A4",
    },
    "main-subtle": {
      default: "#E6EFFE",
      hover: "#ADC9FA",
      active: "#7CA9F7",
    },
    sub: {
      default: "#5d6785",
      hover: "#465173",
      active: "#3c4764",
    },
    "sub-subtle": {
      default: "#e9eaee",
      hover: "#babecb",
      active: "#9aa0b3",
    },
    critical: {
      default: "#c03434",
      hover: "#992a2a",
      active: "#852424",
    },
    "critical-subtle": {
      default: "#FBE9E9",
      hover: "#f4acac",
      active: "#ee8080",
    },
    warning: {
      default: "#FFDA68",
      hover: "#E2B73E",
      active: "#C4992A",
    },
    "warning-subtle": {
      default: "#fffae1",
      hover: "#FFDA68",
      active: "#E2B73E",
    },
    success: {
      default: "#0F796F",
      hover: "#0C5F57",
      active: "#0A524B",
    },
    "success-subtle": {
      default: "#E2EEED",
      hover: "#98CCC7",
      active: "#63B1AA",
    },
    neutral: {
      default: "#666C7A",
      hover: "#505660",
      active: "#454953",
    },
    "neutral-subtle": {
      default: "#F8F9F9",
      hover: "#EDEDED",
      active: "#BFC2C8",
    },
    muted: {
      main: {
        hover: "#F8FAFE",
        active: "#E6EFFE",
      },
      sub: {
        hover: "#f8f9fa",
        active: "#e9eaee",
      },
      critical: {
        hover: "#fef7f7",
        active: "#FBE9E9",
      },
      neutral: {
        hover: "#F8F9F9",
        active: "#EDEDED",
      },
    },
    tinted: {
      main: {
        hover: "rgba(33, 100, 218, 0.04)",
        active: "rgba(33, 100, 218, 0.12)",
      },
      sub: {
        hover: "rgba(93, 103, 133, 0.04)",
        active: "rgba(93, 103, 133, 0.12)",
      },
      critical: {
        hover: "rgba(192, 52, 52, 0.04)",
        active: "rgba(192, 52, 52, 0.12)",
      },
      neutral: {
        hover: "rgba(0, 0, 0, 0.1)",
        active: "rgba(0, 0, 0, 0.2)",
      },
      inverse: {
        hover: "rgba(255, 255, 255, 0.1)",
        active: "rgba(255, 255, 255, 0.2)",
      },
    },
    support: {
      unselected: "#A0A4AD",
      selected: "#666C7A",
      "unselected-strong": "#666C7A",
      disabled: "#EDEDED",
      "disabled-content": "#A0A4AD",
      placeholder: "#A0A4AD",
    },
    links: {
      default: "#2164DA",
      hover: "#1552BC",
      "neutral-default": "#454953",
      "neutral-hover": "#2C2E34",
      "inverse-default": "#ffffff",
      "inverse-hover": "#EDEDED",
    },
  },
  utility: {
    feedback: {
      info: "#2164DA",
      "info-subtle": "#F8FAFE",
      warning: "#FFDA68",
      "warning-subtle": "#fffae1",
      success: "#0F796F",
      "success-subtle": "#F5FAFA",
      critical: "#c03434",
      "critical-subtle": "#fef7f7",
    },
    "focus-default": "#2164DA",
    "focus-inverse": "#ffffff",
    "input-prefilled": "#fffae1",
    ui: "#ffffff",
    "ui-clear": "rgba(255, 255, 255, 0)",
  },
}

export type IsomerBaseColorScheme = "purple"

// We are not using all the shades of the base colour scheme,
// but this is placed here if we need them in the future.
export const baseColourMapping: {
  [k in IsomerBaseColorScheme]: NestedRecord
} = {
  purple: {
    50: "#FBF8FF",
    100: "#EFE7FF",
    200: "#C9B3FF",
    300: "#AA90FA",
    400: "#8C73DB",
    500: "#6D58BB",
    600: "#5543A4",
    700: "#493897",
    800: "#3B2E8A",
    900: "#271E78",
  },
}

// There aren't any more because it should default to design system's
export type IsomerColorScheme =
  | "primary"
  | "secondary"
  | "text"
  | "icon"
  | "background"
  | "border"
  | "base"
  | "interaction"

type BaseRecord = Record<string, string> | NestedRecord | string

interface NestedRecord {
  [x: string]: BaseRecord
}

const legacyColourTokens: { [k in IsomerColorScheme]: NestedRecord } = {
  primary: {
    50: "#F8FAFE",
    100: "#E6EFFE",
    200: "#ADC9FA",
    300: "#7CA9F7",
    400: "#4A89F4",
    500: "#2164DA",
    600: "#1552BC",
    700: "#1248A4",
    800: "#103E8F",
    900: "#0C2E6A",
  },
  secondary: {
    50: "#FBF8FF",
    100: "#EFE7FF",
    200: "#C9B3FF",
    300: "#AA90FA",
    400: "#8C73DB",
    500: "#6D58BB",
    600: "#5543A4",
    700: "#493897",
    800: "#3B2E8A",
    900: "#271E78",
  },
  text: {
    body: "#3D3D3D",
    inverse: "#FFFFFF",
    label: "#2E2E2E",
    helper: "#848484",
    placeholder: "#A0A0A0",
    description: "#474747",
    danger: "#C03434",
    success: "#00774E",
    title: {
      brand: "#2164DA",
      brandSecondary: "#3C4764",
      alt: "#2E2E2E",
    },
    link: {
      disabled: "#A0A0A0",
      default: "#2164DA",
      hover: "#0D4FCA",
      dark: "#3D3D3D",
    },
  },
  base: {
    canvas: {
      brandLight: "#F8FAFE",
      purpleSubtle: baseColourMapping.purple[50],
    },
    content: {
      default: "#3C4764",
      dark: "#272D41",
      light: "#848484",
    },
    divider: {
      medium: "#E9E9E9",
    },
  },
  icon: {
    warning: "#E2B73E",
    default: "#276EF1",
    alt: "#686868",
    danger: "#C03434",
  },
  background: {
    action: {
      default: "#2164DA",
      success: "#00774E",
      defaultInverse: "#FFFFFF",
      warningInverse: "#FFFAE1",
      alt: "#5D6785",
      altInverse: "#F8F9FA",
      infoInverse: "#F7F9FE",
      warning: "#FFEA78",
    },
  },
  border: {
    input: {
      default: "#BFBFBF",
    },
    action: {
      default: "#276EF1",
      light: "#E9E9E9",
    },
    divider: {
      alt: "#E9E9E9",
      active: "#276EF1",
      disabled: "#BFBFBF",
    },
  },
  interaction: {
    mainLight: {
      default: "#F8FAFE",
    },
    support: {
      disabled: "#A0A0A0",
    },
  },
}

// NOTE: Order matters here because we want the updated tokens to override the old tokens
export const colors = _.merge(legacyColourTokens, updatedColorTokens)
